export function tableVias(vis, data) {
  // define data array
  const tabledata = [];

  if (data.resultset != null) {
    for (let i = 0; i < data.resultset.length; i += 1) {
      const htmlUrl = `<div><img class="imgTabulator" src="build/Imagenes/camara.svg">${data.resultset[i][3]}</div>`;
      tabledata.push({
        tram: data.resultset[i][1],
        cam: data.resultset[i][2],
        url: htmlUrl,
      });
    }
  }

  // create Tabulator on DOM element with id "tabulatorMaxCont"
  const table = new Tabulator('#idTableViaPri', {
    selectable: false,
    headerSort: false,
    height: 700, // set height of table (in CSS or here), this enables the
    // Virtual DOM and improves render speed dramatically (can be any valid css height value)
    width: 1000,
    data: tabledata, // assign data to table
    layout: 'fitColumns',
    groupBy: ['tram'],
    columns: [
      {
        title: 'Tram',
        field: 'tram',
        hozAlign: 'center',
        headerHozAlign: 'center',
        formatter: 'html',
      },
      {
        title: 'Descripció Càmera',
        field: 'cam',
        hozAlign: 'center',
        headerHozAlign: 'center',
        width: 560,
      },
      {
        title: 'URL',
        field: 'url',
        hozAlign: 'center',
        headerHozAlign: 'center',
        formatter: 'html',
      },
    ],
  });
}
